package ru.it_mozaika.sender.common.models

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val email: String,
    val role: UserRole = UserRole.User,
    val name: String = "",
    val lastName: String = ""
)

@Serializable
data class CurrentUser(val email: String, val role: UserRole)

@Serializable
enum class UserRole {
    User,
    Admin
}

@Serializable
enum class PasswordChangeType {
    Registration,
    Reset
}

@Serializable
data class CreateUserRequest(
    val name: String,
    val lastName: String,
    val email: String,
    val role: UserRole
)

@Serializable
data class LoginRequest(
    val email: String,
    val password: String
)

@Serializable
data class ResetPasswordRequest(
    val email: String
)

@Serializable
sealed class ChangePasswordRequest {
    @Serializable
    data class ChangePasswordByTokenRequest(
        val email: String,
        val password: String,
        val token: String,
    ) : ChangePasswordRequest()

    @Serializable
    data class ChangePasswordInProfileRequest(
        val password: String,
        val newPassword: String,
    ) : ChangePasswordRequest()
}